<template>
  <div>

    <h1 class="title d-sm-none text-center" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</h1>

    <v-card class="mb-1">
      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-3">
        <v-toolbar-title class="d-none d-sm-block" :class="ativo==true?null:'red--text'">{{ $route.meta.breadCrumb }}</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>
        
        <v-text-field v-model="dataTable.search" append-icon="mdi-magnify" label="Filtrar" single-line hide-details></v-text-field>

      </v-toolbar>

      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-4">
        <v-spacer></v-spacer>
        <v-toolbar-title class="d-none d-sm-block">Ações</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>

        <v-btn @click="dialog=!dialog" title="Cadastrar" icon color="blue darken-2">
          <v-icon>fal fa-plus</v-icon>
        </v-btn>

        <v-btn title="Recarregar dados" icon @click="initialize()" color="orange lighten-1">
          <v-icon>fal fa-repeat</v-icon>
        </v-btn>

        <v-btn :title="ativo?'Mudar para intivos':'Mudar para ativos'" icon @click="ativo=!ativo" :color="ativo==true?'green':'red'">
          <v-icon>fal fa-archive</v-icon>
        </v-btn>

        <ArrayToExcel :dados="dados" :excel="excel"/>

      </v-toolbar>
    </v-card>
    
    <!-- DataTable -->
		<DataTable :dados="dados" :dataTable="dataTable">
      <template v-slot:actions="{item}">
        <v-icon small class="mr-3" title="Editar" @click="editItem(item)">far fa-pencil</v-icon>
        <v-icon small :title="ativo?'Desativar':'Ativar'" @click="deleteItem(item)">far fa-archive</v-icon>
			</template> 
		</DataTable>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="editedItem.nome" label="Nome" :rules="[rules.required, rules.min2]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="editedItem.descricao" label="Descrição" rows="2"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="close"><v-icon left>fal fa-times</v-icon> Fechar</v-btn>
          <v-btn color="blue darken-1" dark @click="save"><v-icon left>fas fa-save</v-icon> Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br style="clear:left;"/> 

	</div>
</template>

<script>
import { mapState } from 'vuex'

import ArrayToExcel from '@/components/ArrayToExcel'
import DataTable from '@/components/DataTable'

export default {
  components: {
    ArrayToExcel,
    DataTable
  },
	data () {
    return {
      server: 'maq_marca',
      ativo: true,
      dialog: false,
      dados: [],
      dataTable: {
        headers: [
          {	text: 'ID', value: 'id' },
          { text: 'Nome', value: 'nome', align: 'start'},
          { text: 'Descrição', value: 'descricao' },
          { text: 'Ações', value: 'actions', sortable: false }
        ],
        sortBy: 'nome',
        sortDesc: false,
        multiSort: false,
        search: '',
        loading: true
      },
      excel: { 
        name: undefined,
        fields: {
          'Id': 'id',
          'Nome': 'nome',
          'Descrição': 'descricao'
        }
      },
			editedIndex: -1,
			editedItem: {
        id: '',
				name: '',
				descricao: ''
			},
			defaultItem: {
        id: '',
				name: '',
				descricao: ''
      }
		}
  },
  computed: {
    ...mapState(
      ['user', 'rules']
    ),
    formTitle () {
      return this.editedIndex === -1 ? 'Cadastrar' : 'Editar'
    }
  },

  watch: {
    dialog(val) { val || this.close() },
    ativo(){ this.initialize() }
  },
  created () {
    this.initialize()
  },

  methods: {
    excelName(){
      this.excel.name = this.$route.meta.breadCrumb+"-"+Date()+".xls"
    },
    initialize(){
      this.excelName()
      this.dataTable.loading = true
      let formData = new FormData()
      formData.append('menu', this.server)
      formData.append('function', 'get_'+this.server)
      formData.append('ativo', this.ativo)
      let vd = this
      
      this.$axiosPost.post('functions.php', formData, 
      { headers: {'Authorization': this.user.token} })
			.then(function (response) {
        if(response.data.error === 0){
          vd.dados = response.data.dados
          setTimeout(function(){ vd.dataTable.loading = false }, 1000)
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
			}).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    editItem(item){
      this.editedIndex = this.dados.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item){
      this.excelName()
      const index = this.dados.indexOf(item)
      let formData = new FormData()
      formData.append('menu', this.server)
      formData.append('function', 'delete_'+this.server)
      formData.append('ativo', !this.ativo)
      formData.append('id', item.id)
      let vd = this
      this.$axiosPost.post('functions.php', formData,
      { headers: {'Authorization': this.user.token} })
      .then(function (response) {
        if(response.data.error === 0){
          vd.dados.splice(index, 1)
          vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType: 0 } )
        }else{
          vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
        }
      }).catch(function(response){
        console.log('ERRO!! '+response);
      })
    },

    close(){
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.$refs.form.resetValidation()
      }, 300)
    },

    save(){
      if(this.$refs.form.validate()){
        if (this.editedIndex > -1) {
          this.excelName()

          let formData = new FormData()
          formData.append('menu', this.server)
          formData.append('function', 'update_'+this.server)
          formData.append('id', this.editedItem.id)
          formData.append('nome', this.editedItem.nome)
          formData.append('descricao', this.editedItem.descricao)
          let vd = this
          this.$axiosPost.post('functions.php', formData,
          { headers: {'Authorization': this.user.token} })
          .then(function (response) {
            if(response.data.error === 0){
              vd.initialize()
              vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType: 0 } )
            }else{
              vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
            }
          }).catch(function(response){
            console.log('ERRO!! '+response);
          })

        }else{

          let formData = new FormData()
          formData.append('menu', this.server)
          formData.append('function', 'insert_'+this.server)
          formData.append('nome', this.editedItem.nome)
          formData.append('descricao', this.editedItem.descricao)
          let vd = this
          this.$axiosPost.post('functions.php', formData,
          { headers: {'Authorization': this.user.token} })
          .then(function (response) {
            if(response.data.error === 0){
              vd.editedItem.id = response.data.id
              vd.initialize()
              vd.$store.dispatch('alert', { alertMessage: response.data.alertMessage, alertType: 0 } )
            }else{
              vd.$store.dispatch('errorServer', { data: response.data, destino: vd.$route.path } )
            }
          }).catch(function(response){
            console.log('ERRO!! '+response);
          })

        }
        
      }
    }
  },
}
</script>